import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

// menu item imports
import { backsplashPropertiesMenuItem } from '../menu-item/backsplash-properties-menu-item';
import { deleteBacksplashMenuItem } from '../menu-item/delete-backsplash-menu-item';
import { insertBacksplashBreakpointMenuItem } from '../menu-item/insert-backsplash-breakpoint-menu-item';
import { pairBacksplashLeftMenuItem, pairBacksplashRightMenuItem, unpairBacksplashMenuItem } from '../menu-item/pair-backsplash-menu-item';
import { stackBacksplashesBlockedMenuItem, stackBacksplashesMenuItem } from '../menu-item/stack-backsplashes-menu-item';
import { unstackBacksplashesMenuItem } from '../menu-item/unstack-backsplashes-menu-item';

export const backsplashMenuList: Array<ContextMenuList> = [
	pairBacksplashLeftMenuItem(),
	pairBacksplashRightMenuItem(),
	unpairBacksplashMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	insertBacksplashBreakpointMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	unstackBacksplashesMenuItem(),
	stackBacksplashesMenuItem(),
	stackBacksplashesBlockedMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	deleteBacksplashMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	backsplashPropertiesMenuItem()
];
